
































import { defineComponent, onMounted, ref } from "@vue/composition-api"
import { useAppBar } from "@/app/reactive/app-bar.state"
import { useBrowser } from "@/app/reactive/browser.state"
import { getLanguage } from "@/app/reactive/language.state"

import DeDataPrivacyPage from "./de/DataPrivacyPage.vue"
import DeConditionsPage from "./de/ConditionsPage.vue"
import EnConditionsPage from "./en/ConditionsPage.vue"
import FrConditionsPage from "./fr/ConditionsPage.vue"
import ItConditionsPage from "./it/ConditionsPage.vue"

export default defineComponent({
  components: {
    DeConditionsPage,
    DeDataPrivacyPage,
    EnConditionsPage,
    FrConditionsPage,
    ItConditionsPage,
  },
  setup(props, { root }) {
    const AppBar = useAppBar()
    const Browser = useBrowser()
    const tab = ref(null)
    const supportedLanguages = ["de", "en", "fr", "it"]
    const localeState = getLanguage(supportedLanguages)

    onMounted(() => {
      AppBar.setTitle("terms.appBarTitle")
      AppBar.setHasBackButton(true)
      Browser.setHasUnsavedData(false)
    })

    return {
      tab,
      localeState,
      navigateBack: () => root.$router.back(),
    }
  },
})
